<template>
<v-card padless class="footer" flat>
  <v-row no-gutters>
    <v-col cols="12" md="4" no-gutters>
      <v-card  no-gutters flat>
        <v-list style="text-align: -webkit-right;">
          <v-list-item v-for="item in items" :key="item.title">
             <v-list-item-content>
              <v-list-item-title v-text="item.title" align="right"></v-list-item-title>
            </v-list-item-content>

            <v-list-item-avatar size="26">
              <v-img src="@/assets/tick.png"></v-img>
            </v-list-item-avatar>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>

    <v-col cols="12" md="4" no-gutters>
      <v-card no-gutters flat>
        <v-list>
          <v-list-item >
            <v-list-item-avatar size="30">
             <v-img src="@/assets/Cog.png"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Easy Integration</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item >
           <v-list-item-content>
              <v-list-item-title>The simple REST API can be integrated into website easily.</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

           <v-list-item >
           <v-list-item-content>
              <v-list-item-title>See the demo application about how you can integrate
              <br />the API using Angular, ReactJs and VueJs frameworks.</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item >
           <v-list-item-content>
              <v-list-item-title>The Documentation provides detailed information about
              <br />the return data and code returned by the GeoAd API.</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
        </v-list>
      </v-card>
    </v-col>

    <v-col cols="12" md="4" no-gutters>
      <v-card no-gutters flat>
        <v-list>
          <v-list-item >
             <v-list-item-avatar size="30">
             <v-img src="@/assets/Cloud_Icon.png"  small></v-img>
             </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Hosted in the Cloud</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item >
           <v-list-item-content>
              <v-list-item-title>GeoAd is hosted in the cloud with typical response times <br/> under 300ms in 95% of cases.</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

           <v-list-item >
           <v-list-item-content>
              <v-list-item-title>The service provides geo-redundancy to ensure<br/> high availability and fast response times.</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item >
           <v-list-item-content>
              <v-list-item-title>The Documentation provides detailed information about
              <br />the return data and code returned by the GeoAd API.</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
    
  </v-row>
</v-card>
</template>
<script>
export default {
  name: "FooterMenu",
  data() {
    return {
      items: [
        { title: "Partial Address Search" },
        { title: "Wildcard Search" },
        { title: "Search By GUID" },
        { title: "Address AutoComplete" },
        { title: " Location Coordinates" }
      ]
    };
  }
};
</script>
<style scoped>
.v-card > *:last-child:not(.v-btn):not(.v-chip) {
    background-color: #02083C;
    height: 250px !important;
   
}
.v-card{
  border-radius: 0%;
  border-right: 2px solid turquoise;
  border-left: 2px solid turquoise;
}


.v-list-item__title, .v-list-item__subtitle{
 color: white !important;
}
</style>